import * as React from "react";
import styled, { css } from "styled-components";
import { Icon, OverlayTrigger, Timestamp } from "components/common";
import { formatInterval } from "aiagent/utils";
const DetailTitle = styled.dt`
  float: left;
  clear: left;
`;
const DetailValue = styled.dd(
  ({ theme }) => css`
    margin-left: 180px;
    overflow-wrap: break-word;

    &:not(:last-child) {
      border-bottom: 1px solid ${theme.colors.variant.lightest.default};
      margin-bottom: 5px;
      padding-bottom: 5px;
    }
  `
);
const DetailsOverlayTrigger = styled(OverlayTrigger)`
  vertical-align: bottom;
`;
const detailsPopover = (workflow) => /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement(DetailTitle, null, "Last execution:"), /* @__PURE__ */ React.createElement(DetailValue, null, workflow.last_run_at ? /* @__PURE__ */ React.createElement(Timestamp, { dateTime: workflow.last_run_at }) : "Never"), /* @__PURE__ */ React.createElement(DetailTitle, null, "Next execution:"), /* @__PURE__ */ React.createElement(DetailValue, null, workflow.next_run_at ? /* @__PURE__ */ React.createElement(Timestamp, { dateTime: workflow.next_run_at }) : "Not scheduled"));
const SchedulingCell = ({ workflow }) => {
  if (workflow.disabled || !workflow.interval_ms) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, "Not scheduled.");
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, `Runs every ${formatInterval(workflow.interval_ms)} `, /* @__PURE__ */ React.createElement(
    DetailsOverlayTrigger,
    {
      trigger: "click",
      rootClose: true,
      placement: "left",
      title: `${workflow.title} details.`,
      overlay: detailsPopover(workflow),
      width: 500
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "info", title: `${workflow.title} details.`, bsStyle: "info" })
  ));
};
export default SchedulingCell;
